<template>
    <v-card>
        <v-card-title>
            Rapport för {{ humanMonth }}
        </v-card-title>
        <v-card-text>

            <v-row no-gutters v-for="person in persons" :key="person.id">
                <v-col
                    cols="10"
                    md="2"
                >
                    {{ person.name }}
                </v-col>
                <v-col
                    cols="2"
                    md="1"
                    class="text-right px-2">
                    {{ person.time }} h
                </v-col>

                <v-col
                    cols="12"
                    sm="9">
                    <svg xmlns="http://www.w3.org/2000/svg" :width="width" height="6">
                        <rect
                            x="0" y="0"
                            height="6" :width="barWidth(person.time)"
                            rx="3"
                            fill="lightblue"
                            />
                    </svg>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        width: {
            type: Number,
            default: 300,
        },
    },
    data: () => ({
        rowHeight: 25,
        persons: [
            {
                id: 1,
                name: "Anders Bengtsson",
                time: 250,
            },
            {
                id: 2,
                name: "Cecilia Davidsson",
                time: 330,
            },
            {
                id: 3,
                name: "Erik Fredriksson",
                time: 300,
            },
            {
                id: 4,
                name: "Greta Henriksson",
                time: 120,
            },
        ]
    }),
    methods: {
        barWidth: function(value) {
            return this.width / this.maxValue * value
        },
    },
    computed: {
        maxValue() {
            const all = this.persons.map((p) => { return p.time })
            return Math.max(...all)
        },
        humanMonth: function() {
            const options = { month: "long" };
            return new Date().toLocaleDateString("sv-SE", options);// this.date.toLocaleDateString("sv-SE", options);
        },
    },
}
</script>